var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDLetter = function SvgDLetter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 126 136"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d-letter_svg__a)",
    d: "M.87 136V0h55.583c20.584 0 37.262 6.234 50.043 18.692q19.16 18.688 19.162 49.263c.002 30.575-6.36 37.044-19.071 49.443C93.875 129.796 77.157 136 56.453 136zm34.147-30.3h21.436q6.536 0 12.08-1.591t10.938-5.494c3.606-2.602 6.431-6.504 8.495-11.707 2.053-5.204 3.085-11.458 3.085-18.783s-1.062-13.749-3.176-18.912c-2.123-5.174-4.948-9.056-8.494-11.658q-5.319-3.903-10.848-5.584-5.544-1.68-12.08-1.681H35.017z",
    className: "d-letter_svg__Vector"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "d-letter_svg__a",
    x1: -565.696,
    x2: 404.059,
    y1: -12.278,
    y2: 118.277,
    className: "d-letter_svg__a",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#983EBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#213DB5"
  })))));
};
export default SvgDLetter;